import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-white" }, "ชำระเงินไม่สำเร็จ! เนื่องจาก", -1)
const _hoisted_4 = { class: "text-white ml-1" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "text-white" }, "ชำระเงินไม่สำเร็จ!", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "p-py-3 p-px-5 p-text-center" }, [
  /*#__PURE__*/_createElementVNode("div", null, "การชำระเงินมีความผิดพลาด"),
  /*#__PURE__*/_createElementVNode("div", null, "กรุณาแก้ไขหลักฐานการชำระเงิน")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Message = _resolveComponent("Message")!
  const _component_TransacrionStatus1 = _resolveComponent("TransacrionStatus1")!
  const _component_TransactionStatus9 = _resolveComponent("TransactionStatus9")!
  const _component_TransactionStatus2 = _resolveComponent("TransactionStatus2")!
  const _component_TransactionStatus3 = _resolveComponent("TransactionStatus3")!
  const _component_TransactionStatus4 = _resolveComponent("TransactionStatus4")!
  const _component_TransactionStatus5 = _resolveComponent("TransactionStatus5")!
  const _component_TransactionOtherStatus = _resolveComponent("TransactionOtherStatus")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_ctx.transaction)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.transaction.statusId == 8)
          ? (_openBlock(), _createBlock(_component_Message, {
              key: 0,
              severity: "error",
              closable: false
            }, {
              default: _withCtx(() => [
                (_ctx.transaction.reasonNote !== '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _hoisted_3,
                      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.transaction.reasonNote), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.transaction.statusId == 1)
          ? (_openBlock(), _createBlock(_component_TransacrionStatus1, { key: 1 }))
          : _createCommentVNode("", true),
        (_ctx.transaction.statusId == 9)
          ? (_openBlock(), _createBlock(_component_TransactionStatus9, { key: 2 }))
          : _createCommentVNode("", true),
        (_ctx.transaction.statusId == 2)
          ? (_openBlock(), _createBlock(_component_TransactionStatus2, { key: 3 }))
          : _createCommentVNode("", true),
        ([3, 8].includes(_ctx.transaction.statusId))
          ? (_openBlock(), _createBlock(_component_TransactionStatus3, { key: 4 }))
          : _createCommentVNode("", true),
        ([4, 10, 11].includes(_ctx.transaction.statusId))
          ? (_openBlock(), _createBlock(_component_TransactionStatus4, { key: 5 }))
          : _createCommentVNode("", true),
        (_ctx.transaction.statusId == 5)
          ? (_openBlock(), _createBlock(_component_TransactionStatus5, { key: 6 }))
          : _createCommentVNode("", true),
        ([6, 7].includes(_ctx.transaction.statusId))
          ? (_openBlock(), _createBlock(_component_TransactionOtherStatus, { key: 7 }))
          : _createCommentVNode("", true),
        _createVNode(_component_Dialog, {
          visible: _ctx.displayPosition,
          "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.displayPosition) = $event)),
          position: "center",
          modal: true,
          dismissableMask: "",
          showHeader: false,
          class: "payment-fail-dialog"
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }, 8, ["visible"])
      ]))
    : _createCommentVNode("", true)
}